import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { FormikAutoSubmit } from '../../../../components/atoms/formikAutoSubmit';
import { contactSourceOptions } from '../../../../components/organisms/contactsFilters/defaultFilters';

export const SourceFilter = ({ value, setFilters }) => {
  const onSubmit = ({ sources }) => {
    // sources is an array of selected options
    const selectedSources = sources || [];
    setFilters({ sources: selectedSources });
  };

  // Convert stored value back to options format for the select
  const selectedValues = Array.isArray(value)
    ? value.map(
        (v) => contactSourceOptions.find((opt) => JSON.stringify(opt.value) === JSON.stringify(v.value || v)) || v,
      )
    : [];

  return (
    <Formik initialValues={{ sources: selectedValues }} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="sources"
          label="Source"
          placeholder="Any"
          component={FormAsyncMultiSelect}
          defaultOptions={contactSourceOptions}
          size="small"
          anchorToBody
          isMulti
        />
      </Form>
    </Formik>
  );
};

SourceFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

SourceFilter.defaultProps = {
  value: [],
};
